import type { EditorPlugin } from './../../ricos-types';

import { breakout } from './extension';

export const pluginBreakout: EditorPlugin = {
  type: 'BREAKOUT',
  config: {},
  tiptapExtensions: [breakout],
  shortcuts: [],
  textButtons: [],
};
